"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var recompose_1 = require("recompose");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var react_router_dom_1 = require("react-router-dom");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('jobName', 'setJobName', ''), (0, recompose_1.withState)('notes', 'setNotes', ''), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.selectedJob !== prevProps.selectedJob &&
            this.props.selectedJob &&
            this.props.update) {
            this.props.setJobName(this.props.selectedJob.name);
            this.props.setNotes(this.props.selectedJob.new_revision.notes);
        }
    }
}), recompose_1.pure);
var addJob = function (newJob, jobs) {
    if (jobs) {
        return __spreadArray(__spreadArray([], jobs, true), [newJob], false);
    }
    return [newJob];
};
exports.default = enhance(function (props) {
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'diary-entry-modal-add-job' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.closeModal();
                props.setJobName('');
                props.setNotes('');
                props.setJobStatus('');
            } }, !props.update
            ? (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/addJob')
            : (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/editJob')),
        React.createElement("div", { className: "add-job-modal-started-jobs" },
            (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/jobStarted'),
            React.createElement(sok_ui_1.TextInput, { className: 'started-job-input-box', value: props.jobName, disabled: props.isDisabled, onChange: function (e) {
                    return props.setJobName(e.target.value);
                } })),
        React.createElement("div", { className: "add-job-modal-daily-info" },
            (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/dailyNotes'),
            React.createElement(sok_ui_1.TextInput, { className: 'daily-info-input-box', value: props.notes, type: "textarea", rows: 6, disabled: props.isDisabled, onChange: function (e) {
                    return props.setNotes(e.target.value);
                } })),
        React.createElement("div", { className: "add-job-modal-choose-job-status" },
            (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/selectWorkStatus'),
            React.createElement(sok_ui_1.Grid.Row, null,
                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                    React.createElement(sok_ui_1.WorksiteStatus, { icon: "fa-play-circle", name: 'WorksiteStatus', label: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/started'), elementClassName: 'blue', elementStyle: {
                            width: '180px',
                            display: 'inline-block'
                        }, value: 'STARTED', disabled: props.isDisabled, onChange: function (e) {
                            return props.setJobStatus(e.target.value);
                        }, defaultChecked: props.jobStatus === 'STARTED' })),
                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                    React.createElement(sok_ui_1.WorksiteStatus, { icon: "fa-angle-double-right", name: 'WorksiteStatus', label: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/inProgress'), elementClassName: 'blue', elementStyle: {
                            width: '180px',
                            display: 'inline-block'
                        }, value: 'IN_PROGRESS', disabled: props.isDisabled, onChange: function (e) {
                            return props.setJobStatus(e.target.value);
                        }, defaultChecked: props.jobStatus === 'IN_PROGRESS' }))),
            React.createElement(sok_ui_1.Grid.Row, null,
                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                    React.createElement(sok_ui_1.WorksiteStatus, { icon: "fa-check-circle", name: 'WorksiteStatus', label: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/done'), elementClassName: 'green', elementStyle: {
                            width: '180px',
                            display: 'inline-block'
                        }, value: 'DONE', disabled: props.isDisabled, onChange: function (e) {
                            return props.setJobStatus(e.target.value);
                        }, defaultChecked: props.jobStatus === 'DONE' })),
                React.createElement(sok_ui_1.Grid.Column, { small: 6 },
                    React.createElement(sok_ui_1.WorksiteStatus, { icon: "fa-pause-circle", name: 'WorksiteStatus', label: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/onHold'), elementClassName: 'black', elementStyle: {
                            width: '180px',
                            display: 'inline-block'
                        }, value: 'ON_HOLD', disabled: props.isDisabled, onChange: function (e) {
                            return props.setJobStatus(e.target.value);
                        }, defaultChecked: props.jobStatus === 'ON_HOLD' })))),
        React.createElement(sok_ui_1.Footer, { className: "add-job-modal-footer" },
            React.createElement("div", { className: "add-job-modal-buttons" },
                React.createElement(sok_ui_1.Button, { className: "add-job-modal-add-button", size: "medium", color: "green", text: props.update
                        ? (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/edit')
                        : (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/add'), disabled: props.isDisabled, onClick: function () {
                        if (props.update &&
                            props.selectedJob &&
                            props.selectedJobIndex !== undefined &&
                            props.jobs) {
                            props.setJobStatus(props.selectedJob.new_revision.status);
                            var updatedJob = __assign(__assign({}, props.jobs[props.selectedJobIndex]), { name: props.jobName, new_revision: __assign(__assign({}, props.jobs[props.selectedJobIndex].new_revision), { status: props.jobStatus, updated_at: Date.now(), notes: props.notes }) });
                            var updatedJobs = props.updateJob(props.selectedJobIndex, updatedJob, props.jobs);
                            props.setJobsList(updatedJobs);
                        }
                        else if (!props.update && props.jobs) {
                            var newJob = {
                                name: props.jobName,
                                new_revision: {
                                    status: props.jobStatus,
                                    updated_at: Date.now(),
                                    notes: props.notes
                                }
                            };
                            var newJobs = addJob(newJob, props.jobs);
                            props.setJobsList(newJobs);
                        }
                        props.closeModal();
                        props.setJobName('');
                        props.setNotes('');
                        props.setJobStatus('');
                    } }),
                React.createElement(sok_ui_1.Button, { className: "add-job-modal-cancel-button", size: "medium", color: "dark-gray", text: (0, translation_1.getLocalization)('diaryEntryView/worksiteStatus/cancel'), onClick: function () {
                        props.closeModal();
                        props.setJobName('');
                        props.setNotes('');
                        props.setJobStatus('');
                    } })))));
});
